var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control control--input"},[_c('Icon',{staticClass:"control__icon",attrs:{"name":_vm.icon}}),_vm._v(" "),_c('input',_vm._g(_vm._b({ref:"control",staticClass:"control__input",attrs:{"aria-invalid":'' + _vm.invalid + '',"aria-errormessage":_vm.errorMessageId}},'input',{
      id: _vm.id,
      name: _vm.name,
      required: _vm.required,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      type: _vm.type,
      min: _vm.min,
      max: _vm.max,
      autocomplete: _vm.autocomplete,
      inputmode: _vm.inputmode,
      value: _vm.value,
    },false),_vm.listeners)),_vm._v(" "),(_vm.invalid)?_c('Icon',{staticClass:"control__icon control__icon--error",attrs:{"name":"16-warning","width":16,"height":16,"viewBox":"0 0 16 16"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }